import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/constants/routerPath';
import { KEYS } from 'src/app/constants/keys';
import { isBlank, isPresent } from 'src/app/utils/utils';
import { ChartType, GoogleChartsModule } from 'angular-google-charts';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'controls-bo-donutchart',
  imports: [CommonModule, GoogleChartsModule],
  templateUrl: './bo-donutchart.component.html',
  styleUrls: ['./bo-donutchart.component.scss']
})
export class BoDonutchartComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  chartType = ChartType.PieChart;

  myData = [
    ['Women', 28],
    ['Men', 72]
  ];
  options = {
    // colors: ['#f28202', '#f908b6', '#ff953b', '#ff3b5b'],

    colors: ['#69d141', '#6852c8', '#ff953b', '#ff3b5b'],
    title: '',
    legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    pieHole: 0.3,
    pieSliceText: 'label',
    pieSliceTextStyle: { fontName: 'Hellix,sans-serif' },
    // slices: {
    //   1: { offset: 0.1 }
    // },
    chartArea: {
      bottom: 20,
      left: 20,
      right: 50,
      top: 20
    }
  }
  cStyle: any = {};
  pagename = '';
  pageid = '';
  menuData: any = [];
  chartclick = '';
  colors: any;
  OnSelect(event: any) {
    const clickid = (isPresent(this.chartForm.value.chartclick) ? this.chartForm.value.chartclick : 'false')

    if (clickid == 'true') {
      this.commonService.get_specificpageid().subscribe((data: any) => {

        if (data['table']) {
          const datas = data['table'][0];
          this.pageid = datas.gstibo_exp_page_id;
        }

        this.commonService.get_specificpage(this.pageid).subscribe((pageData: any) => {
          if (pageData['table'].length > 0) {
            const tododata = pageData['table'][0];
            const pageDetails = {
              pageId: tododata.gstibo_page_id,
              pageName: tododata.gstibo_page_name,
              parentMenuId: tododata.gstibo_parent_menu_id,
              menuId: tododata.gstibo_menu_id,
              withChildMenues: tododata.gstibo_with_child_menues,
              withChildInnerPage: tododata.gstibo_with_child_inner_page,
              isAddMode: false
            }
            const userAccountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
            this.commonService.loadMenuForUser(userAccountID).subscribe((data: any) => {
              if ((data['table'].length > 0)) {
                this.menuData = data['table'];
              }
              sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
              const parentMenuId = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!).parentMenuId;
              let parentmenu = this.menuData.filter((item: any) => item.gstibo_menu_id == parentMenuId.toString())[0].gstibo_menu_name;
              this.commonService.setParentMenuName(parentmenu);
              sessionStorage.setItem('moduleName', parentmenu);
              this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
            });
          }
        },
          error => {
            console.log('getPageTablenameAndPrimaryKey Error:', error);
          });
      });

    }
  }
  constructor(private commonService: CommonService,
    private router: Router) { }

  ngOnInit(): void {
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
      this.colors = this.chartForm.value.colors;
      this.commonService.ogLog('this.colorsdonut', this.colors)
      if (this.colors)
        this.options.colors = this.colors;
      let chartArea = this.chartForm.value.chartArea;
      if (chartArea)
        this.options.chartArea = chartArea;
    }
  }

}
